export default "__VITE_ASSET__Dntjh_G5__"